import React, { useState,useEffect } from "react";
import Header from '../../layout/header';
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import axios from 'axios'
import ReactPaginate from 'react-paginate';
import BottomMenu from "../../layout/bottomMenu";
import NotFoundData from "../../../Images/no-data-found.webp";
import Moment from "moment/moment";
import LastActivityModal from "../../Parking/Activity/LastActivityModal/lastActivityModal";
import callWebService, {callTypes} from "../../../service/Networks/network";
import Config from "../../../service/Config/config";

const SitesCalling = ({
    getAccountsForCalling,
    referralAccountList=[],
    getSiteListingFilters,
    siteCallingfilters=[],
    match
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('')
    const [filterView, setfilterView] = useState([{}])
    const [requiredDataOnChange, setRequiredDataOnChange] = useState([{City: ''}])
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [pageNo, setPage] = useState(1)
    const [roleId, setRoleId] = useState("")
    const [filterInputList, setFilterInputList] = useState([{}])
    const [open, setOpen] = useState(false);
    const [showMom, setShowMom] = useState(false);
    const [selectedAccountId,setSelectedAccountId]=useState('');
    const [previousActivities,setPreviousActivities]=useState([]);
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);

    useEffect(() => {
        let webView = localStorage.getItem('webview');
        if(webView !== undefined && webView == 'true') {
            const message = {
                event_name: 'screenshot_prevent',
                page_name: 'yes',
            }
            const nativeObject = window.ReactNativeWebView;
            if (nativeObject !== undefined) {
                setTimeout(function () {
                    nativeObject.postMessage(JSON.stringify(message));
                    window.addEventListener('message', () => {
                    })
                  }, 100);
            }
        }
    }, []);

    useEffect(async() => {
        setIsLoading(true)
        await getSiteListingFilters();
        await getAccountsForCalling();
        setIsLoading(false)
    }, [])


    const onPageChange = async (val) => {
        setIsLoading(true);
        setPage(val?.selected + 1);
        await getAccountsForCalling(val?.selected + 1,filterInputList,searchValue)
        setIsLoading(false);
    };
    const handleSearch = async () => {
        setIsLoading(true)
        await getAccountsForCalling(pageNo,filterInputList,searchValue)
        setIsLoading(false)
    }
    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        window.localStorage.siteCallingFilter = JSON.stringify(filterInputList)
        await getAccountsForCalling(pageNo, filterInputList,searchValue)
        setIsLoading(false)
    }

    const handleFilter = async (key, value, stringValue = '') => {
        const list = [...filterInputList]
        const view = [...filterView]
        list[0][key] = value
        view[0][key] = value
        if (stringValue !== '') {
            view[0][key] = stringValue
            setfilterView(view)
        } else {
            setfilterView(view)
        }
        setFilterInputList(list)
    }

    const handleRemoveFilter = async (key) => {
        if(key !== ''){
            delete filterView[0][key]
            delete filterInputList[0][key]
            setfilterView(filterView)
            setFilterInputList(filterInputList)
            setIsLoading(true)
            if(filterInputList[0].length === 0){
                delete window.localStorage.siteCallingFilter
            } else {
                window.localStorage.referralFilter = JSON.stringify(filterInputList)
            }
            await getAccountsForCalling()
            setIsLoading(false)
        }
    }
    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setfilterView([{}])
                setFilterInputList([{}])
                setIsLoading(true)
                await getAccountsForCalling(pageNo, filterInputList, searchValue)
                setIsLoading(false)
                setIsRemoveFilter(false)
            }

        })()
    }, [isFilterRemove])

    useEffect(() => {
        if(selectedAccountId!='' && selectedAccountId!=undefined){
            setIsLoading(true)
            fetchData()
            setIsLoading(false)
        }
    }, [selectedAccountId])

    const handleModalClose = () => {
        setIsLoading(true)       
        setShowMom(false);
        setIsLoading(false)
        };

    const fetchData = async () => {
       try {
         const token = await localStorage.getItem('token');
         const base_url = process.env.REACT_APP_API_URL;
         const response = await callWebService(callTypes.get,  '',`${Config?.getPreviousActivities}?account_id=${selectedAccountId}&based_on_assign_to=${false}`);
           if(response !== null && response?.data !== null && response?.data?.response!=null && response?.data?.response?.data?.length>0 ){
               setPreviousActivities(response?.data?.response?.data)
           }
       }catch(error) {
         setIsLoading(false)
         console.error('Failed to fetch activity MOM:', error);
         return;
       }
   };

    return (
        <>
            <>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <Loader isLoading={isLoading}/>
            {showMom && previousActivities && previousActivities.length>0 &&
               <LastActivityModal
                   title={`Last Activity's MOM`}
                   activities={previousActivities.map(act => {
                       // Extracting product and service details
                       const product = act.meta_data?.[0]?.product?.[0]?.name
                       const serviceDetails = act.meta_data?.[0]?.service_details?.find(service => service.selected);
                       const solutionDetails = act.meta_data?.[0]?.solution_details?.find(solution => solution.selected);
                       const formattedReason = Array.isArray(act?.reason)
                       ? act?.reason?.[0]?.reason
                       : act?.reason;
                       return {
                           activity_type:act.activity_type,
                           project_type_name:act.project_type_name,
                           assigned_to_name:act.assigned_to_name,
                           mom: act.meta_data?.[0]?.MOM||act.meta_data?.[0]?.mom,
                           introduction: act.meta_data?.[0]?.Introduction,
                           meetingType: act.meta_data?.[0]?.Meeting_Type,
                           remark: act.meta_data?.[0]?.remark,
                           tagged_along_name: act?.tagged_along_name,
                           activity_date: act?.activity_date,
                           description: act?.description,
                           meeting_outcome: act?.meeting_outcome?.[0]?.Outcome,
                           purpose_of_visit: act?.purpose_of_visit?.[0]?.visit_purpose,
                           reason: formattedReason,
                           product: product,
                           serviceId: serviceDetails?.id,
                           solutionId: solutionDetails?.id,
                           valet_client_mom:act?.meta_data?.[0]?.Client_Alignment?.[0]?.Client_Mom,
                           sub_activity_type:act?.sub_activity_type,
                           comment:act?.meta_data?.[0]?.Comment,
                           internal_mom:act?.meta_data?.[0]?.internal_mom,
                           payment_collection_mom: act?.meta_data?.[0]?.payment_collection_details?.[0]?.payment_collection_mom,
                           relationship_meeting_mom:act?.meta_data?.[0]?.relationship_meeting_details?.[0]?.relationship_meeting_mom,
                           meeting_mom:act?.meta_data?.[0]?.Client_Alignment?.[0]?.Meeting_MoM
                       };
                   })}
                   show={showMom}
                   handleModalHide={() => {
                       handleModalClose();
                   }}
                   prevButtonText={'Go back'}
                   nextButtonText={'Previous Meeting'}
                   finalButtonText={'Close'}
               />
           }
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Sites for Calling'}
                        />
                        {/* <InnerMobileHeader
                          title={'Account List'}
                         /> */}
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="row b-13">
                                    {/*<div className="form-check form-switch global-search">*/}
                                    {/*    <input type="checkbox" id="switch" onChange={(e) => setIsGlobalSearch(e.target.checked)}/>*/}
                                    {/*    <label className="radio-btn" for="switch">Global Search</label>*/}
                                    {/*    <span className="serach-title">Search account globally..</span>*/}
                                    {/*</div>*/}
                                </div>
                                <div className="d-sm-flex align-items-center justify-content-between mt-2 mb-2">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px">
                                            <form className="form-inline mr-auto w-90 navbar-search">
                                                <div className="d-flex w-100">
                                                    <input type="text"
                                                           className="form-control bg-light border-0 small list-filter"
                                                           placeholder={"Search Account..."}
                                                           aria-label="Search"
                                                           aria-describedby="basic-addon2"
                                                           onChange={(e) => {
                                                               setSearchValue(e.target.value)
                                                           }}
                                                    />
                                                    {/* <div className="remove-search-filter">
                                                        <i className="fa fa-times" aria-hidden="true" onClick={removeSearchFilter}></i>
                                                    </div> */}
                                                    <div className="btn-search">
                                                        <button className="btn btn-primary lh-32 border-left-tr-tb"
                                                                type="button"
                                                                onClick={(e) => handleSearch()}
                                                        >
                                                            <i className="fas fa-search fa-sm"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                            {/* <h1 className="h3 mb-0 text-black-100">Accounts</h1> */}
                                        </div>
                                        <div className="col-md-6 cs-pos">
                                            <button 
                                            onClick={() => setOpen(!open)}
                                                    className="btn btn-sm btn-primary mr-1 btn-filter btn-filter-2"
                                                    type="button"><i
                                                className="fa fa-filter lh-35 pd-3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/* Filter View */}
                                {console.log(filterInputList)}
                                {filterView[0] !== undefined && Object.keys(filterView[0]).length > 0 &&
                                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                        <div className="row pd-filter-div">
                                            <div className="col-md-12 col-sm-12 d-flex">
                                                <div className="applied-filter">
                                                    {Object.keys(filterView[0]).map((val, i) => {
                                                        return (
                                                            <>
                                                            <span className="fd-1">
                                                                <span style={{textTransform: "capitalize"}}>
                                                                    {val.replaceAll("_", " ")}
                                                                </span>
                                                                {" - " + filterView[0][val]}
                                                                <i className="bi bi-x-circle" onClick={(e) => {
                                                                    handleRemoveFilter(val)
                                                                }}></i></span>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/* Filter View End*/}
                                <div className="row">
                                    {/*CARD START*/}
                                    {referralAccountList && referralAccountList?.data !== undefined && referralAccountList?.data?.length>0 && referralAccountList?.data.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow">
                                                        <div className="card card-just-text" data-background=""
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category mrg-b-12">
                                                                   
                                                                    {val?.stage === "Hot" ? (
                                                                            <div className="header-ui-item-opp" style={{backgroundColor: "#f39c12"}}>
                                                                                Hot
                                                                            </div>
                                                                        ) :  (
                                                                            <div className="header-ui-item-opp" style={{backgroundColor: "#3498db"}}>
                                                                                Negotiation
                                                                            </div>
                                                                        )}

                                                                    <div className="row">
                                                                        <div className="col-10" style={{
                                                                            color: "#000",
                                                                            fontSize: "20px",
                                                                            textAlign: "left",
                                                                            paddingLeft: "20px"
                                                                        }}>
                                                                            <div className="d-flex">
                                                                                {val?.client_name}
                                                                            </div>

                                                                        </div>
                                                                        <div className="col-2"
                                                                            style={{
                                                                                position: 'relative',
                                                                                display: 'inline-block',
                                                                                cursor: 'pointer',
                                                                              }}
                                                                            // onMouseEnter={() => setIsTooltipVisible(true)}
                                                                            // onMouseLeave={() => setIsTooltipVisible(false)}
                                                                            >
                                                                            {/* <div class="tooltip"> */}
                                                                                <i class="fa fa-eye"
                                                                                onClick={()=>{
                                                                                    setSelectedAccountId(val?.id)
                                                                                    setShowMom(true)
                                                                                }}
                                                                                style={{ fontSize: '18px' }}
                                                                                ></i>
                                                                                {isTooltipVisible && (
                                                                                        <span
                                                                                        style={{
                                                                                            position: 'absolute',
                                                                                            top: '50%',
                                                                                            right: '75%',
                                                                                            transform: 'translateY(-50%)',
                                                                                            width: '150px',
                                                                                            backgroundColor: '#555',
                                                                                            color: '#fff',
                                                                                            textAlign: 'center',
                                                                                            padding: '5px',
                                                                                            borderRadius: '6px',
                                                                                            opacity: 1,
                                                                                            transition: 'opacity 0.3s',
                                                                                            zIndex: 1,
                                                                                        }}
                                                                                        >
                                                                                        View Last 3 meetings MOM
                                                                                        </span>
                                                                                    )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="row list-view">
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-id-card"></i>&nbsp;&nbsp;Account ID
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                    <span 
                                                                                    className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.id}>
                                                                                        {val?.id}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-map-marker"></i>&nbsp;&nbsp;Address
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                    <span 
                                                                                    className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.address_1}>
                                                                                        {val?.address_1}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-city"></i>&nbsp;&nbsp;City
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                    <span 
                                                                                    className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.city_name}>
                                                                                        {val?.city_name}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-globe"></i>&nbsp;&nbsp;State
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                    <span 
                                                                                    className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.state_name}>
                                                                                        {val?.state_name}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-person-lines-fill"></i>&nbsp;&nbsp;Assigned To
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1">
                                                                                        {val?.assigned_to_name}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                    
                                                                    </div>
                                                                    <hr/>
                                                                    <div className="row list-view-links">
                                                                        <ul>
                                                                            <li><a
                                                                                href={`referral-call-form/${val?.id}`}
                                                                                >
                                                                                <i className="bi-person-plus"></i>&nbsp;Fill Referral Form</a>
                                                                            </li>
                                                                            <li><a
                                                                                href={`view-call-logs/${val?.id}`}
                                                                                >
                                                                                <i className="bi bi-list"></i>&nbsp;View Logs</a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}

                                    {referralAccountList && referralAccountList?.data !== undefined && referralAccountList?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(referralAccountList?.total / referralAccountList?.per_page)}
                                                forcePage={referralAccountList?.current_page - 1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }

                                    {referralAccountList && referralAccountList?.data !== undefined && referralAccountList?.data.length === 0 &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data"/>
                                            <div className="text-center" style={{"width": "100%"}}>
                                                Data Not Found
                                            </div>
                                        </>
                                    }
                                    {/*PAGINATION END*/}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    handleSubmitFilter={handleSubmitFilter}
                    filterContent={siteCallingfilters}
                    handleFilter={handleFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
            {/* section ends */}
        </>
        </>
      );
};

export default SitesCalling;